import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { Button } from "@mui/material";


type Props = {
    onActionExportar: (idContaPagar: number) => void

}

export const GenerateContasPagarRecuperarColumns = ({
    onActionExportar,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Em Aberto"; // EM ABERTO
            case 1: // PAGO
                return "Pago";
            case 2: // OUTROS
                return "Outros";
            case 3: // ATRASADAS
                return "Atrasada";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "gray"; // em aberto
            case 1: // PAGO
                return "green";
            case 2: // OUTROS
                return "yellow";
            case 3: // ATRASADA
                return "red";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "Conta em aberto";
            case 1: // PAGO
                return "Conta Paga";
            case 2: // OUTROS
                return "Outros";
            case 3: // EM ABERTO
                return "Conta atrasada";
            default:
                return "?";
        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "nrContasPagar",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "titulo",
            filterable: false,
            headerName: "Título/Pedido",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nomeFornecedor",
            filterable: false,
            headerName: "Fornecedor/funcionário",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nroOrdemCompra",
            filterable: false,
            headerName: "OC",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "valorPagar",
            filterable: false,
            headerName: "Valor Pagar",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataPagar",
            filterable: false,
            headerName: "Data Pagar",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorPago",
            filterable: false,
            headerName: "Valor Pago",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataPago",
            filterable: false,
            headerName: "Data Pago",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "deletadaPor",
            filterable: false,
            headerName: "Deletada Por",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "deletadaData",
            filterable: false,
            headerName: "Deletada Em",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            sortable: false,
            valueGetter: (_, row) => row['idContasPagar'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => onActionExportar(value)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },
    ];

}